//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
export async function addDataIntoCache (cacheName, url, response) {
    const data = new Response(JSON.stringify(response));

    if ('caches' in window) {
        const cache = await caches.open(cacheName);
        if (cache && response.status === 200) {
            await cache.put(url, data);
        }
    }
    else {
        return undefined;
    }
}

export async function checkIfDataIsCached (cacheName, url) {
    if ('caches' in window) {
        const cache = await caches.open(cacheName);
        if (cache) {
            const match = await cache.match(url);
            if (match) {
                const response = await match.json();
                return(response);
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
}

export async function clearAllCachedData (cacheName) {
    if ('caches' in window) {
        const cache = await caches.open(cacheName);
        if (cache) {
            const keys = await cache.keys();
            await Promise.all(keys.map((x) => cache.delete(x)));
        }
    }
}